<template>
  <v-form @submit.prevent="handleChangePassword" validate-on="submit eager">
    <v-card title="Set Password">
      <v-card-text class="d-flex flex-column ga-2">
        <v-text-field
          v-if="props.useToken"
          :rules="[rules.required]"
          type="text"
          hide-details="auto"
          label="Reset Code"
          v-model="resetToken"
        />
        <v-text-field
          v-if="enterPassword"
          :append-inner-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
          :rules="[rules.required]"
          :type="show1 ? 'text' : 'password'"
          hide-details="auto"
          label="Current Password"
          v-model="currentPassword"
        />
        <v-text-field
          :append-inner-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
          :rules="[rules.required, rules.min]"
          :type="show1 ? 'text' : 'password'"
          hide-details="auto"
          label="New Password"
          v-model="newPassword"
          @click:append-inner="show1 = !show1"
        />
        <v-text-field
          :append-inner-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
          :rules="[rules.required, rules.min, rules.match(newPassword)]"
          :type="show1 ? 'text' : 'password'"
          hide-details="auto"
          label="Confirm New Password"
          @click:append-inner="show1 = !show1"
        />
      </v-card-text>
      <v-card-actions>
        <v-btn
          v-if="props.isActive"
          text="Cancel"
          @click="props.isActive.value = false"
        ></v-btn>
        <v-btn
          :loading="loading"
          text="Update Password"
          color="primary"
          variant="flat"
          type="submit"
          :block="props.useToken"
        ></v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script setup lang="ts">
import router from "@/router";
import { useAuthStore } from "@/stores/auth";
import { useNotificationStore } from "@/stores/notification";
import { ref } from "vue";

const authStore = useAuthStore();

const notificationStore = useNotificationStore();

const props = defineProps<{
  isActive: Ref<boolean> | undefined;
  useToken: boolean;
  enterPassword: boolean;
}>();

const rules = {
  required: (value: string) => !!value || "Required.",
  min: (v: string) => v.length >= 8 || "Min 8 characters",
  match: (value1: string) => (value2: string) =>
    value1 == value2 || "The passwords you entered don't match",
};

const handleChangePassword = async (a: any) => {
  loading.value = true;
  try {
    const b = await a?.then();
    if (b.valid) {
      if (props.useToken) {
        authStore.updateEscalationToken(authStore.decodeJwt(resetToken.value));
      }
      if (props.enterPassword) {
        try {
          await authStore.escalateUserSession(currentPassword.value);
        } catch (e) {
          return;
        }
      }
      const result = await authStore.updatePassword(newPassword.value);
      console.log(result);
      if (!result)
        notificationStore.addSnackbar("Error updating password", "error");
      if (props.isActive) {
        props.isActive.value = false;
      }
      if (props.useToken) {
        router.push("/");
      }
    }
  } catch (e) {
    notificationStore.addSnackbar("Error updating password", "error");
  } finally {
    loading.value = false;
  }
};

const loading = ref(false);
const show1 = ref(false);
const resetToken = ref(window.location.hash.substring(1));
const currentPassword = ref("");
const newPassword = ref("");
</script>
